import styled from 'styled-components'
// views
import { AddButton } from 'components/Modals/SystemProcessModal/Form/components/views'

export const Wrapper = styled('div')`
  height: 288px;
  width: fit-content;
  padding: 8px 0;
  min-width: 250px;
  max-width: 50vw;
`

export const OptionWrapper = styled('div')`
  > span {
    font-size: 12px;
    font-weight: 500;
    margin-left: 12px;
    color: hsl(0, 0%, 60%);
  }
`

export const Option = styled('div')`
  cursor: pointer;
  padding: 11px 16px;
  display: inherit;

  &:hover {
    background-color: #d3d1d2;
  }
`

// @ts-ignore
export const Button = styled(AddButton)`
  position: absolute;
  top: -10px;
  right: -31px;
`
